module.exports = __webpack_public_path__ + "static/media/huatiao7.9a294c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/huatiao7.png
// module id = 384
// module chunks = 0 1